import React, { useState, useEffect } from "react";
import { FacilityCard } from "../../Facilities/FacilityCard";
import { Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { resetState } from "../../../../redux/actions/dbactions/orderFormActions";
import { NewCalender } from "./NewCalender";
import { Header } from "../../../Header";
import OrdersIcon from "../../../../../assets/OrdersIcon";

export const OrderCard = ({ exploreList }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [selectedID, setSelectedID] = useState(null);
  const [selectedProID, setSelectedProID] = useState(null);
  const [serviceUser, setServiceUser] = useState("");

  // Fetch newOrder from local storage
  useEffect(() => {
    const newOrder = JSON.parse(localStorage.getItem("newOrder"));
    if (newOrder) {
      const firstName = newOrder.service_user; //.split(" ")[0];
      setServiceUser(firstName);
    }
  }, []);

  const handleCalenderOpen = (svcf_id, cal, services, svcf_user_profile_id) => {
    setOpen(true);
    setSelectedID(svcf_id);
    setSelectedProID(svcf_user_profile_id);
  };

  return (
    <div>
      <Header pageTitle="My Orders > Add Order" icon={<OrdersIcon />} />
      <div className="ser_title_b px-8 mt-4">
        <h5>Available Facilities For {serviceUser}</h5>
        <button
          onClick={() => dispatch(resetState())}
          className="sign_btn !text-sm"
        >
          Again Explore
        </button>
      </div>
      <Row className="px-8 m-0">
        {exploreList.map((item) => (
          <Col className="mb-3" key={item.id} lg={4} md={6}>
            <FacilityCard
              handleCalenderOpen={() => handleCalenderOpen(item.svcf_id, null, null, item.svcf_user_profile_id)}
              data={item}
              route={"addorder"}
            />
          </Col>
        ))}
      </Row>
      <NewCalender
        selectedID={selectedID}
        selectedProID={selectedProID}
        show={open}
        onHide={() => setOpen(false)}
        dispatch={dispatch}
        userName={serviceUser}
      />
    </div>
  );
};
